"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var hooks_1 = require("../../../../hooks");
var Dropdown_1 = __importDefault(require("../../inputs/Dropdown"));
var KrajDropdown = function (_a) {
    var onChange = _a.onChange, value = _a.value, enableReset = _a.enableReset, inputId = _a.inputId;
    var _b = hooks_1.useCiselnik('soudniKraje'), loading = _b.loading, error = _b.error, data = _b.data;
    if (loading) {
        return react_1.default.createElement(react_1.default.Fragment, null, "na\u010D\u00EDt\u00E1n\u00ED");
    }
    if (error) {
        return react_1.default.createElement("div", null, error);
    }
    var options = (data || []).map(function (item) { return ({ value: item.id, label: item.nazev }); });
    return (react_1.default.createElement(Dropdown_1.default, { inputId: inputId, placeholder: "Vyberte ze seznamu", name: "kraj", value: value, onChange: onChange, loadOptions: function () { return Promise.resolve(options); }, enableReset: enableReset }));
};
KrajDropdown.defaultProps = {
    value: undefined,
    enableReset: false,
    inputId: undefined,
};
exports.default = KrajDropdown;
